module.exports = __webpack_public_path__ + "static/img/index.3643515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index.png
// module id = OBd5
// module chunks = 1